﻿import $ from 'jquery';
import { PdfUrlBuilder } from './pdfurlbuilder';

declare var Pace: any;
export interface IDocumentViewUi {
  renderFailed(): void;
  displayDocument(): void;
}

export class DocumentDataPoll {
  private api: Api;
  private retryDuration = 60000;
  private isRetryTimedOut = false;

  constructor(private isAvailableUrl: string, private ui: IDocumentViewUi) {
    this.api = new Api(isAvailableUrl);
  }

  public view(): void {
    this.loadPreview();
    setTimeout(() => {
      this.isRetryTimedOut = true;
    }, this.retryDuration);
  }

  private loadPreview(): void {
    this.api.isPdfAvailable((result) => { this.checkForPdf(result); });
  }

  private checkForPdf(isPdfAvailable) {
    if (this.isRetryTimedOut)
      this.ui.renderFailed();
    else if (isPdfAvailable)
      this.ui.displayDocument();
    else {
      setTimeout(() => { this.loadPreview(); }, 1000);
    }
  }
}

export class DefaultDocumentViewUi implements IDocumentViewUi {
  constructor(private dataUrl: string, private $ui: JQuery) { }
  $spinner = this.$ui.find('.view-spinner');
  $loading = this.$spinner.find('.preview-loading');
  $failed = this.$spinner.find('.preview-failed');

  renderFailed(): void {
    this.$loading.hide();
    this.$failed.show();
  }

  displayDocument(): void {
    this.$spinner.remove();
    var url = new PdfUrlBuilder().build(this.dataUrl);
    let frame = $("<iframe id='view-document' src=" + url + "></iframe>");
    this.$ui.append(frame);
  }
}

class Api {
  constructor(private isAvailableUrl: string) {
  }
  isPdfAvailable = (callback: Function) => {
    if (typeof (Pace) == 'undefined')
      $.get(this.isAvailableUrl, callback);
    else
      Pace.ignore(() => { //kill this dependency
        $.get(this.isAvailableUrl, callback);
      });
  };
}

$(() => {
  $(document).on("mouseenter", "[data-documentviewer] .direct-download-link a", () => {
    $("[data-documentviewer] .preview-icon").addClass("icon-smile");
  });
  $(document).on("mouseleave", "[data-documentviewer] .direct-download-link a", () => {
    $("[data-documentviewer] .preview-icon").removeClass("icon-smile");
  });
});
